<template>
  <div id="home-search">
    <v-container grid-list-xs pb-0>
      <v-layout align-center justify-center row wrap>
        <v-flex mt-5 sm6 xs10>
          <div class="display-2 font-weight-bold my-2 head-page spacing">ผลผลิต</div>
          <div class="display-2 font-weight-bold my-2 head-page spacing">ที่คุณสนใจ?</div>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex mt-2 sm6 xs10>
          <!-- append-outer-icon="search" -->
          <BaseAutocompleteProduct
            append-icon="search"
            autofocus
            @input="onSearch"
            v-model.trim="searchKey"
          />
          <!-- <v-text-field hide-details label="ค้นหาผลผลิต" single-line solo></v-text-field> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'home-search',
  data() {
    return {
      searchKey: ''
    }
  },
  computed: {},
  methods: {
    async onSearch() {
      // search log
      const ipAddress = await this.axios.get(`https://ipinfo.io/json?token=c4f8622271bdb1`)
      const data = {
        keyword: this.searchKey.productName,
        ip: ipAddress.data.ip,
        pages: 'home-page'
      }
      await this.axios.post(`farmerspace/search-log`, data)
      this.$router.push({
        name: 'product-search',
        params: { productId: window.btoa(this.searchKey.productId) }
      })
    }
  }
}
</script>

<style></style>
